<template>
  <template v-if="this.$store.state.vMode == 0">
    <div class="cabinet-top-wrapper" :data-amodal-data="getJsonId">
      <div class="cabinet-top" :class="{ loading: $store.state.loading }" :title="getTitle">
        <div class="photo-small">
          <img :src="getPhotoSrc" v-if="getPhotoSrc"/>
        </div>
        <span class="cabinet-top-txt-pc">{{ getTitleShort }}</span>
      </div>
    </div>
  </template>
  <template v-else>
    <div class="position-relative">
      <div class="cabinet-mobile-wrap">
        <div class="cabinet-mobile-title">
          {{ getTitle }}
        </div>
      </div>
    </div>
    <div class="cabcard" :class="{ loading: $store.state.loading }" :data-amodal-data="getJsonId">
      <div class="photo">
        <img :src="getPhotoSrc" v-if="getPhotoSrc"/>
      </div>
      <div class="body">
        <div class="header">{{ getTitle }}</div>
        <div class="sub" v-if="getType == 0">
          <div v-if="getCapacity"><span class="icon users"></span>{{ getCapacity }}</div>
          <div v-if="getArea"><span class="icon area"></span>{{ getArea }} м²</div>
        </div>
        <div class="sub desc" v-else-if="getType == 2">
          <div>Место в солевой комнате</div>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
// import { Modal } from 'bootstrap'
// import {Bootstrap,Modal} from 'bootstrap'

export default {
  name: "CabCard",
  props: {
    cabId: Number,
    officeId: Number
  },
  created() {
    // console.log(this.officeId);
    // console.log(this.$store.state.cabinet.data.cabinetsInfo)
  },
  computed: {
    getTitleShort() {
      let title = this.$store.state.cabinet.data.cabinetsInfo[this.officeId][this.cabId]['name'];
      let titleArr = title.split(' ');
      return titleArr[0];
    },
    getJsonId() {
      let res = {'id': this.$store.state.cabinet.data.cabinetsInfo[this.officeId][this.cabId]['cabinet_id']};
      return JSON.stringify(res);
    },
    getId() {
      return this.$store.state.cabinet.data.cabinetsInfo[this.officeId][this.cabId]['cabinet_id'];
    },
    getPhotoSrc() {
      return this.$store.state.cabinet.data.cabinetsInfo[this.officeId][this.cabId]['photoSrc']['thumb_url'];
    },
    getTitle() {
      return this.$store.state.cabinet.data.cabinetsInfo[this.officeId][this.cabId]['name'];
    },
    getArea() {
      return this.$store.state.cabinet.data.cabinetsInfo[this.officeId][this.cabId]['area'];
    },
    getCapacity() {
      return this.$store.state.cabinet.data.cabinetsInfo[this.officeId][this.cabId]['capacity'];
    },
    getType() {
      return this.$store.state.cabinet.data.cabinetsInfo[this.officeId][this.cabId]['type'];
    },
  },
  methods: {
    // openBootstrap5Modal(){
    //   var myModal = new Modal(document.getElementById('view-info-cabinet'))
    //   myModal.toggle()
    // }
  }
}
</script>

<style scoped>

.cabinet-top{
  height: auto!important;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem 0.2rem 0.2rem 0.2rem;
  cursor: pointer;
  justify-content: flex-start;
}

.photo-small{
  text-align: center;
}

.photo-small img{
  max-width: 60px;
  border-radius: 5px;
}



.cabcard {
  position: relative;
  /*height: calc(4rem + 1px);*/
  height: 4rem;


  /*background: #fff;*/
  /*transition: all ease .7s;*/
  transition: opacity ease .7s;
  align-items: center;
  width: 250px;
  display: flex;
  flex-direction: row;
  /*background: #f2f2f2;*/
  will-change: transform;
}


.cabcard:hover {
  cursor: pointer;
}

.cabcard:before {
  position: absolute;
  content: '';
  width: 100%;
  top: 0;
  border-top: 1px solid #f5f5f5;
}

.cabcard:last-child:after {
  position: absolute;
  content: '';
  width: 100%;
  left: 0;
  bottom: 0;
  border-bottom: 1px solid #f5f5f5;
}


.cabcard .photo {
  display: flex;
  align-items: center;
  flex-direction: row;
  background: #c9c9c9;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  min-width: 45px;
  min-height: 45px;
}

.cabcard .photo img {
  display: block;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  min-width: 45px;
  min-height: 45px;
  position: relative;

}

.cabcard:hover .photo:before {
  content: '';
  z-index: 1;

  position: absolute;
  display: block;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  min-width: 45px;
  min-height: 45px;
  background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.83931 6.74556C4.3292 5.25567 6.66714 3.75 10 3.75C13.3329 3.75 15.6708 5.25567 17.1607 6.74556C17.9038 7.4887 18.4397 8.23076 18.7906 8.78809C18.9664 9.06724 19.0966 9.30146 19.184 9.4683C19.2277 9.55176 19.2608 9.61849 19.2835 9.66569C19.2949 9.6893 19.3037 9.70804 19.3099 9.72157L19.3174 9.7379L19.3197 9.74306L19.3206 9.74487L19.3209 9.74558C19.321 9.74588 19.3211 9.74616 18.75 10C19.3211 10.2538 19.321 10.2541 19.3209 10.2544L19.3206 10.2551L19.3197 10.2569L19.3174 10.2621L19.3099 10.2784C19.3037 10.292 19.2949 10.3107 19.2835 10.3343C19.2608 10.3815 19.2277 10.4482 19.184 10.5317C19.0966 10.6985 18.9664 10.9328 18.7906 11.2119C18.4397 11.7692 17.9038 12.5113 17.1607 13.2544C15.6708 14.7443 13.3329 16.25 10 16.25C6.66714 16.25 4.3292 14.7443 2.83931 13.2544C2.09617 12.5113 1.5603 11.7692 1.20939 11.2119C1.03362 10.9328 0.903373 10.6985 0.815984 10.5317C0.772267 10.4482 0.739205 10.3815 0.716476 10.3343C0.705109 10.3107 0.696319 10.292 0.690066 10.2784L0.682582 10.2621L0.680256 10.2569L0.679445 10.2551L0.679127 10.2544C0.678993 10.2541 0.678868 10.2538 1.25 10C0.678868 9.74616 0.678993 9.74588 0.679127 9.74558L0.679445 9.74487L0.680256 9.74306L0.682582 9.7379L0.690066 9.72157C0.696319 9.70804 0.705109 9.6893 0.716476 9.66569C0.739205 9.61849 0.772267 9.55176 0.815984 9.4683C0.903373 9.30146 1.03362 9.06724 1.20939 8.78809C1.5603 8.23076 2.09617 7.4887 2.83931 6.74556ZM1.25 10L0.678868 9.74616C0.607044 9.90777 0.607044 10.0922 0.678868 10.2538L1.25 10ZM1.94882 10C2.02235 10.1377 2.12794 10.3248 2.26718 10.5459C2.58033 11.0433 3.06008 11.7074 3.72319 12.3706C5.0458 13.6932 7.08286 15 10 15C12.9171 15 14.9542 13.6932 16.2768 12.3706C16.9399 11.7074 17.4197 11.0433 17.7328 10.5459C17.8721 10.3248 17.9777 10.1377 18.0512 10C17.9777 9.86227 17.8721 9.67524 17.7328 9.4541C17.4197 8.95674 16.9399 8.29255 16.2768 7.62944C14.9542 6.30683 12.9171 5 10 5C7.08286 5 5.0458 6.30683 3.72319 7.62944C3.06008 8.29255 2.58033 8.95674 2.26718 9.4541C2.12794 9.67524 2.02235 9.86227 1.94882 10ZM18.75 10L19.3211 10.2538C19.393 10.0922 19.393 9.90777 19.3211 9.74616L18.75 10Z' fill='%23EFEFEF'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5ZM6.25 10C6.25 7.92893 7.92893 6.25 10 6.25C12.0711 6.25 13.75 7.92893 13.75 10C13.75 12.0711 12.0711 13.75 10 13.75C7.92893 13.75 6.25 12.0711 6.25 10Z' fill='%23EFEFEF'/%3E%3C/svg%3E%0A");

  background-size: 50%;
  background-position: center;
  background-repeat: no-repeat;
}

.cabcard .body {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  margin-left: .5rem;
}

.cabcard .body .header {
  /*width: 190px;*/
  font-size: .75rem;
  /*white-space: nowrap;*/
  /*overflow: hidden;*/
  /*text-overflow: ellipsis;*/
  transition: all ease .4s;
}

.cabcard:hover .body .header {
  color: #ca820f;
}

.cabcard .body .sub {
  margin-top: 2px;
  font-size: .75rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.cabcard .body .sub.desc {
  font-size: .65rem;
  color: #777;
}

.cabcard .body .sub > * {
  margin-right: .5rem;
}

.cabcard .sub .icon {
  background-size: 100%;
  top: 2px;
  width: .75rem;
  height: .75rem;
}

.cabcard .sub .icon.users {
  background-size: 119%;
  top: 4px;
  width: 1rem;
  height: 1rem;

}
.cabinet-top-wrapper{
  margin-right: 1px;
  margin-left: 1px;
  display: flex;
}
.cabinet-top-txt-pc{
  font-size: 0.8rem;
  padding-top: 5px;
}
.vertical .xsize-1 .cabinet-top-wrapper{
  min-width: unset;
}

.vertical .xsize-2 .cabinet-top-wrapper{
  //min-width: calc(((100% - 4rem) / 15) - 0.21px)!important;
  min-width: 60px!important;
}

.vertical .xsize-3  .cabinet-top-wrapper{
  //min-width: calc(((100% - 4rem) / 10) - 0.21px)!important;
  min-width: 100px!important;
}

/** ICON */
.icon {
  position: relative;
  display: inline-block;
  width: 1rem;
  /*height: 1rem;*/
  background-repeat: no-repeat;
  background-position: bottom;
  margin-right: .3rem;

}

.icon.users {
  background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 33 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.166 20C14.7559 20 17.666 17.0899 17.666 13.5C17.666 9.91015 14.7559 7 11.166 7C7.57616 7 4.66602 9.91015 4.66602 13.5C4.66602 17.0899 7.57616 20 11.166 20Z' stroke='%23E07A5F' stroke-width='2' stroke-miterlimit='10'/%3E%3Cpath d='M19.5911 7.2375C20.1657 7.08166 20.7582 7.00181 21.3536 7C23.0775 7 24.7308 7.68482 25.9498 8.90381C27.1687 10.1228 27.8536 11.7761 27.8536 13.5C27.8536 15.2239 27.1687 16.8772 25.9498 18.0962C24.7308 19.3152 23.0775 20 21.3536 20' stroke='%23E07A5F' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M2.16602 24.675C3.18095 23.2307 4.52856 22.0519 6.09503 21.2381C7.66149 20.4243 9.40079 19.9995 11.166 19.9995C12.9312 19.9995 14.6705 20.4243 16.237 21.2381C17.8035 22.0519 19.1511 23.2307 20.166 24.675' stroke='%23E07A5F' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M21.3535 20C23.1189 19.9989 24.8585 20.4232 26.4252 21.237C27.9918 22.0508 29.3393 23.2301 30.3535 24.675' stroke='%23E07A5F' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
}

.icon.area {
  margin-top: 3px;
  background-image: url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%23E07A5F' class='bi bi-arrows-fullscreen' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707zm0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707zm-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707z'/%3E%3C/svg%3E");
}

/*.position-relative{*/
/*  position: relative;*/
/*}*/
.cabinet-mobile-wrap {
  display: none;
}

.cabinet-mobile-title {
  overflow: hidden;
  font-size: .8rem;
  max-width: 90vw;
  white-space: nowrap;
  text-overflow: ellipsis;
}

@media (max-width: 670px) {

  .photo-small img{
    max-width: 90%;
    border-radius: 5px;
  }

  .cabinet-mobile-wrap {
    display: block;
    position: absolute;
    top: 0;
    line-height: 2rem;
    height: 2rem;
    padding-left: .5rem;

  }

  /*.cabcard-wrap{*/
  /*  padding-top: 2rem;*/
  /*}*/
  .cabcard {
    max-width: 120px;
    padding-left: .5rem;
    margin-top: 2rem;
  }

  .cabcard .body .header {
    display: none;
  }

  .cabcard .body .sub {

    margin-top: 0px;
    font-size: .75rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
  }

}

</style>
<script setup>
</script>